<template>
  <div class="detail-container">
    <h1 class="page-title">顧客マスタ情報詳細</h1>
    <div v-if="customer">
      <table class="table table-bordered">
        <tr>
          <th>ID</th>
          <td>{{ customer.id }}</td>
        </tr>
        <tr>
          <th>顧客名</th>
          <td class="multiline-text">{{ customer.customer_nm }}</td>
        </tr>
        <tr>
          <th>顧客番号</th>
          <td>{{ customer.customer_no }}</td>
        </tr>
        <tr>
          <th>所属する本社</th>
          <td v-if="customer.parent_customer">
            {{ customer.parent_customer.customer_nm }}（ID: {{ customer.parent_customer.id }}）
          </td>
          <td v-else>未設定（本社または単独顧客）</td>
        </tr>
        <tr v-if="branches.length">
          <th>紐づいている支店</th>
          <td>
            <div v-for="branch in branches" :key="branch.id">
              {{ branch.customer_nm }}（ID: {{ branch.id }}）<span v-if="branch.del_flg == 1" class="text-muted">・削除済み</span>
            </div>
          </td>
        </tr>
        <tr>
          <th>所在地</th>
          <td>〒{{ customer.postal_code }} {{customer.prefecture}}{{customer.city}}{{customer.other_address}}</td>
        </tr>
        <tr>
          <th>電話番号</th>
          <td>{{ customer.tel_num }}</td>
        </tr>
        <tr>
          <th>FAX</th>
          <td>{{ customer.fax }}</td>
        </tr>
        <tr>
          <th>代表者名</th>
          <td>{{ customer.president_nm }}</td>
        </tr>
        <tr>
          <th>請求先名</th>
          <td>{{ customer.billing_nm }}</td>
        </tr>
        <tr>
          <th>入金予定</th>
          <td class="text-nowrap">
            {{
              {
                0: "翌月15日",
                1: "翌月25日",
                2: "翌月末",
                3: "翌々月5日",
                4: "翌々月10日"
              }[customer.billing_timing_type]
            }}
          </td>
        </tr>
        <tr>
          <th>請求締切</th>
          <td class="text-nowrap">
            {{
              {
                0: "5日",
                1: "10日",
                2: "15日",
                3: "20日",
                4: "25日",
                5: "月末"
              }[customer.billing_deadline]
            }}
          </td>
        </tr>
        <tr>
          <th>振込先口座</th>
          <td>
            <div v-if="customer.m_banks && customer.m_banks.length">
              <div v-for="bank in customer.m_banks" :key="bank.id">
                {{ bank.bank_nm }} {{ bank.branch_nm }} {{ bank.account_type }} {{ bank.account_no }}
              </div>
            </div>
            <div v-else>
              未設定
            </div>
          </td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'CustomerList', params: { id: customer.id }, query: route.query }"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'CustomerEdit', params: { id: customer.id }, query: route.query }"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      顧客情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getCustomer } from '@/api/axios';

export default {
  setup() {
    const title = ref('顧客情報詳細');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const customer = ref({});
    const customerId = route.params.id;
    const branches = computed(() => {
      return customer.value.branch_customers || [];
    });

    const fetchCustomer = async () => {
      const response = await getCustomer(customerId);
      customer.value = response.data;
    };

    onMounted(fetchCustomer);

    return {
      title,
      userRole,
      customer,
      branches,
      route
    };
  }
};
</script>
